import { useQueryParam } from '@cosuno/react-hooks';
import { useState } from 'react';

export const usePasswordlessLoginTokenQueryParam = (): {
  passwordlessLoginToken: string | null;
} => {
  const [passwordlessLoginToken, setPasswordlessLoginToken] = useState<string | null>(null);

  useQueryParam('passwordlessLoginToken', (token) => {
    if (!token || typeof token !== 'string') return;

    setPasswordlessLoginToken(token);
  });

  return { passwordlessLoginToken };
};
